/* eslint-disable max-classes-per-file */

export class WrongParamsError extends Error {
  constructor(message: string, public params: any) { super(message) }
}

export class EntityNotFoundError extends Error {
  constructor(message: string, public params: any) { super(message) }
}

export class OfflineDocConflictError extends Error {
  constructor(message: string, public doc: any) { super(message) }
}
